"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopTeamToJSON = exports.TopTeamFromJSONTyped = exports.TopTeamFromJSON = void 0;
const _1 = require("./");
function TopTeamFromJSON(json) {
    return TopTeamFromJSONTyped(json, false);
}
exports.TopTeamFromJSON = TopTeamFromJSON;
function TopTeamFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ..._1.PlacingFromJSONTyped(json, ignoreDiscriminator),
        'isClosed': json['isClosed'],
        'isFinished': json['isFinished'],
    };
}
exports.TopTeamFromJSONTyped = TopTeamFromJSONTyped;
function TopTeamToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ..._1.PlacingToJSON(value),
        'isClosed': value.isClosed,
        'isFinished': value.isFinished,
    };
}
exports.TopTeamToJSON = TopTeamToJSON;
